// ----------------------------------------------------------------------
// Global location for sidebar width, DashboardSidebar
export const DRAWER_WIDTH = 245;
export const COLLAPSE_WIDTH = 102;
